export const VendorDetailOffersListPageSize = 6;
export const VendorDetailOffersListPageSize = 6;
